// extracted by mini-css-extract-plugin
export default {"canvasElement":"CanvasElement_canvasElement__fKhxg","fillWidth":"CanvasElement_fillWidth__fRU-Z","fillHeight":"CanvasElement_fillHeight__S6Z51"};